/**
 * Client-capture header names — the small, additive contract by which the web
 * client hands the api the launch context that ISN'T in Telegram `initData`
 * (platform / Telegram-client version / IANA timezone). The api's
 * `data_collection`-gated per-session capture reads these headers; the web
 * client sets them on every request (guarded for non-Telegram/undefined). Kept
 * here so both ends agree on the exact lowercase header keys with no duplication.
 *
 * NB: the client IP is NOT a client header — it is read server-side from
 * `CF-Connecting-IP` / `X-Forwarded-For` (a client cannot be trusted to report
 * its own IP), so it deliberately has no constant here.
 */

/** Telegram WebApp `platform` (e.g. `ios` / `android` / `tdesktop` / `web`). */
export const CLIENT_PLATFORM_HEADER = "x-tg-platform";

/** Telegram WebApp `version` (the Bot-API/client version, e.g. `7.10`). */
export const CLIENT_VERSION_HEADER = "x-tg-version";

/** The browser's IANA timezone (`Intl.DateTimeFormat().resolvedOptions().timeZone`). */
export const CLIENT_TIMEZONE_HEADER = "x-tz";
